import { action, makeAutoObservable, observable, runInAction } from 'mobx';
import { HTTP_STATUS_RESPONSE_KEY } from 'src/constants/api';
import { MortgageDealItemType } from 'src/constants/mortgage-deal';
import { ResponseDTO } from 'src/dto/base.dto';
import {
	AcceptOneMortgageProposalListDTO,
	GetMortgageProposalListDTO,
	RejectAllMortgageProposalListDTO
} from 'src/dto/funder-investment.dto';
import { IBorrowerDealProposals } from 'src/interfaces/mortgage-deal/investment';
import { HttpService } from 'src/services/http.service';

export interface IBorrowerInvestmentStore {
	proposalsInfo: IBorrowerDealProposals;
	getData(mortgageId: string): Promise<boolean>;
	rejectAll(mortgageId: string): Promise<boolean>;
	accept(mortgageId: string, biddingId: string): Promise<boolean>;
	dispose(): void;
}

export class BorrowerInvestmentStore implements IBorrowerInvestmentStore {
	proposalsInfo: IBorrowerDealProposals = {
		mortgageNumber: '',
		borrowCurrency: '',
		borrowAmount: 0,
		id: '',
		city: '',
		district: '',
		zipCode: 0,
		addressLine: '',
		status: MortgageDealItemType.Draft,
		biddingInformation: []
	};

	constructor(private readonly http: HttpService) {
		makeAutoObservable(this, {
			proposalsInfo: observable,
			dispose: action.bound
		});
	}
	public async getData(mortgageId: string): Promise<boolean> {
		const dto = new GetMortgageProposalListDTO({
			mortgageId
		});
		const rs: ResponseDTO<IBorrowerDealProposals> = await this.http.request(dto);
		if (rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				if (rs.data) {
					this.proposalsInfo = {
						...rs.data
					};
				}
			});
			return true;
		}
		return false;
	}

	public async rejectAll(mortgageId: string): Promise<boolean> {
		const dto = new RejectAllMortgageProposalListDTO({
			mortgageId
		});
		const rs: ResponseDTO<IBorrowerDealProposals> = await this.http.request(dto);
		if (rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				if (rs.data) {
					this.proposalsInfo = {
						...rs.data
					};
				}
			});
			return true;
		}
		return false;
	}
	public async accept(mortgageId: string, biddingId: string): Promise<boolean> {
		const dto = new AcceptOneMortgageProposalListDTO(
			{
				mortgageId
			},
			{
				biddingId
			}
		);
		const rs: ResponseDTO<IBorrowerDealProposals> = await this.http.request(dto);
		if (rs.responseKey == HTTP_STATUS_RESPONSE_KEY.SUCCESS) {
			runInAction(() => {
				if (rs.data) {
					this.proposalsInfo = {
						...rs.data
					};
				}
			});
			return true;
		}
		return false;
	}

	public dispose(): void {
		this.proposalsInfo = {
			mortgageNumber: '',
			borrowCurrency: '',
			borrowAmount: 0,
			id: '',
			city: '',
			district: '',
			zipCode: 0,
			addressLine: '',
			status: MortgageDealItemType.Draft,
			biddingInformation: []
		};
	}
}
